export default __webpack_public_path__ + "b59b18e3e4ac4973f045d136dc8ae6a8.jpg";